
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.65 7.406a1.25 1.25 0 11.036 1.25h-.662l-2.456 5.969c-.25.609-1.15.467-1.2-.19l-.75-9.641-1.894 5.75c-.222.675-1.218.515-1.218-.195 0-1.93-.387-2.724-1.006-2.724-.28 0-.35.072-.37.44a.625.625 0 01-.624.591H1.63a.625.625 0 110-1.25h.36c.217-.651.747-1.031 1.51-1.031.88 0 1.486.46 1.847 1.32l2.06-6.253C7.62.793 8.57.908 8.622 1.589l.787 10.135 1.617-3.93a.625.625 0 01.578-.388h1.045z"}})])
          )
        }
      }
    